<div class="copy-groups">
	<div class="group" *ngFor="let g of message.content?.groups">
		<div class="group-header">
			<mat-icon inline>label</mat-icon>
			<span class="title">
				{{ g.title }}
			</span>
		</div>
		<div class="items">
			<div class="item" *ngFor="let it of g.items" [class.added]="isAdded(it)">
				<div class="body">{{ it.text }}</div>
				<div class="actions">
					<button class="ribbon-button p-2" (click)="add(it, g.title)" *ngIf="!isAdded(it)">
						<mat-icon inline>add</mat-icon>
						<ng-container i18n="Button Label@@aiCopySuggestionsAddButtonLabel">Add</ng-container>
					</button>
					<button class="ribbon-button p-2 active" disabled *ngIf="isAdded(it)">
						<mat-icon inline>check</mat-icon>
						<ng-container i18n="Button Label@@aiCopySuggestionsAddedButtonLabel">Added</ng-container>
					</button>
					<button mat-icon-button (click)="copyToClipboard(it, g.title)" tp="Copy to clipboard" i18n-tp="Layer Action@@adLayerRowCopyToClipboard">
						<mat-icon inline *ngIf="copyToClipboardId !== it.id ">content_copy</mat-icon>
						<mat-icon inline class="text-success" *ngIf="copyToClipboardId === it.id ">check</mat-icon>
					</button>
				</div>
			</div>
		</div>

		<button class="ribbon-button p-2 add-all mt-3 mb-3" *ngIf="!isAllAdded(g.items)" (click)="addAll(g)">
			<mat-icon inline>add</mat-icon>
			<ng-container i18n="Button Label@@aiCopySuggestionsAddAllOptionsButtonLabel">Add all {{ g.title }} Options</ng-container>
		</button>
		<button class="ribbon-button p-2 add-all mt-3 mb-3 active" disabled *ngIf="isAllAdded(g.items)">
			<mat-icon inline>check</mat-icon>
			<ng-container i18n="Button Label@@aiCopySuggestionsAddedAllOptionsButtonLabel">Added all {{ g.title }} Options</ng-container>
		</button>

	</div>
</div>
